import { jwtDecode } from "jwt-decode";

function formatChemicalFormula(text) {
    if (typeof text !== 'string') return text;

    const parts = text.split(/(CO2)/g);
    return (
        <>
            {parts.map((part, i) =>
                part === "CO2" ? <span key={i}>CO<sub>2</sub></span> : part
            )}
        </>
    );
}

function isQuarterlyFillDate(years) {
    const today = new Date();
    const currentYear = new Date().getFullYear() + 543;  // แปลงปีให้เป็นพุทธศักราช
    const month = today.getMonth() + 1; // เพิ่ม 1 เพื่อให้เดือนตรงกับปฏิทินปกติ
    const date = today.getDate();
    const year = parseInt(years);

    const quarterlyMonths = [1, 4, 7, 10];

    //เปิดให้กรอกตั้งแต่วันนี้จนถึง 31 ส.ค. 67 (NEW Condition!!)
    if (year === 2567 && month === 8 && date <= 31) {
        return true;
    }

    //เปิดให้กรอกตั้งแต่วันนี้จนถึง 1-10 ธ.ค. (NEW Condition!!)
    if ((year === 2567 && month === 12 && date <= 10) || (year === 2568 && month === 12 && date <= 10)) {
        return true;
    }

    // เงื่อนไขพิเศษ: เปิดให้กรอกตั้งแต่วันนี้จนถึง 6 มิ.ย. 67, 68
    if (
        (year === 2567 && (month < 6 || (month === 6 && date <= 6))) ||
        (year === 2568 && (month < 6 || (month === 6 && date <= 6)))
    ) {
        return true;
    }

    if ((year === 2567 && month === 11 && date <= 20) || (year === 2568 && month === 4 && date <= 25)) {
        return true;
    }

    if (year === currentYear) {
        return quarterlyMonths.includes(month) && date <= 15;
    }

    // if (year === currentYear - 1) {
    //   return month <= 5; // อนุญาตให้กรอกข้อมูลปีก่อนหน้าได้ถ้ายังไม่เกินเดือนพฤษภาคมของปีปัจจุบัน
    // }

    return false;
};

const isTokenExpired = (token) => {
    try {
        const decoded = jwtDecode(token);
        const currentTime = Date.now() / 1000; // เปลี่ยนเป็นวินาที
        return decoded.exp < currentTime;
    } catch (error) {
        return true; // ถ้า decode ไม่ได้ ให้ถือว่าหมดอายุ
    }
};

const formatNumber = (value) => {
    if (isNaN(value) || value === null) return "0.00";
    return parseFloat(value).toLocaleString(undefined, { 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2 
    });
};

const fiscalMonthOrder = (month) => month >= 10 ? month - 9 : month + 3;

const getFiscalYear = (year, month) => {
    // ปีงบเริ่ม ต.ค. 2026 เป็นต้นไป
    if (year >= 2026 && month >= 10) {
        return year + 1;
    }
    return year;
};

const sortByYearMonth = (a, b) => {
    const fyA = getFiscalYear(a.years, a.month);
    const fyB = getFiscalYear(b.years, b.month);

    if (fyA !== fyB) {
        return fyA - fyB;
    }

    if (fyA >= 2026) {
        return fiscalMonthOrder(a.month) - fiscalMonthOrder(b.month);
    }

    return a.month - b.month;
};

export { formatChemicalFormula, isQuarterlyFillDate, isTokenExpired, formatNumber, fiscalMonthOrder, getFiscalYear, sortByYearMonth };